function cov_eb2cf78kx() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Sentry.tsx";
    var hash = "ebfe623b4889890c2935b222f6ab64942de79795";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Sentry.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 33
                }
            },
            "1": {
                start: {
                    line: 8,
                    column: 26
                },
                end: {
                    line: 8,
                    column: 44
                }
            },
            "2": {
                start: {
                    line: 9,
                    column: 23
                },
                end: {
                    line: 9,
                    column: 25
                }
            },
            "3": {
                start: {
                    line: 18,
                    column: 27
                },
                end: {
                    line: 18,
                    column: 31
                }
            },
            "4": {
                start: {
                    line: 21,
                    column: 2
                },
                end: {
                    line: 21,
                    column: 15
                }
            },
            "5": {
                start: {
                    line: 23,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 8
                }
            },
            "6": {
                start: {
                    line: 27,
                    column: 2
                },
                end: {
                    line: 30,
                    column: 4
                }
            },
            "7": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 35,
                    column: 27
                }
            },
            "8": {
                start: {
                    line: 37,
                    column: 2
                },
                end: {
                    line: 37,
                    column: 55
                }
            },
            "9": {
                start: {
                    line: 41,
                    column: 2
                },
                end: {
                    line: 43,
                    column: 3
                }
            },
            "10": {
                start: {
                    line: 42,
                    column: 3
                },
                end: {
                    line: 42,
                    column: 30
                }
            },
            "11": {
                start: {
                    line: 46,
                    column: 19
                },
                end: {
                    line: 54,
                    column: 2
                }
            },
            "12": {
                start: {
                    line: 47,
                    column: 2
                },
                end: {
                    line: 49,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 48,
                    column: 3
                },
                end: {
                    line: 48,
                    column: 30
                }
            },
            "14": {
                start: {
                    line: 51,
                    column: 2
                },
                end: {
                    line: 53,
                    column: 3
                }
            },
            "15": {
                start: {
                    line: 52,
                    column: 3
                },
                end: {
                    line: 52,
                    column: 29
                }
            },
            "16": {
                start: {
                    line: 57,
                    column: 35
                },
                end: {
                    line: 57,
                    column: 45
                }
            },
            "17": {
                start: {
                    line: 58,
                    column: 20
                },
                end: {
                    line: 58,
                    column: 30
                }
            },
            "18": {
                start: {
                    line: 59,
                    column: 29
                },
                end: {
                    line: 59,
                    column: 45
                }
            },
            "19": {
                start: {
                    line: 60,
                    column: 24
                },
                end: {
                    line: 60,
                    column: 29
                }
            },
            "20": {
                start: {
                    line: 62,
                    column: 2
                },
                end: {
                    line: 110,
                    column: 3
                }
            },
            "21": {
                start: {
                    line: 63,
                    column: 3
                },
                end: {
                    line: 74,
                    column: 4
                }
            },
            "22": {
                start: {
                    line: 68,
                    column: 4
                },
                end: {
                    line: 68,
                    column: 27
                }
            },
            "23": {
                start: {
                    line: 69,
                    column: 4
                },
                end: {
                    line: 73,
                    column: 30
                }
            },
            "24": {
                start: {
                    line: 70,
                    column: 5
                },
                end: {
                    line: 70,
                    column: 60
                }
            },
            "25": {
                start: {
                    line: 72,
                    column: 5
                },
                end: {
                    line: 72,
                    column: 30
                }
            },
            "26": {
                start: {
                    line: 76,
                    column: 3
                },
                end: {
                    line: 109,
                    column: 5
                }
            },
            "27": {
                start: {
                    line: 112,
                    column: 2
                },
                end: {
                    line: 112,
                    column: 29
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 20,
                        column: 1
                    },
                    end: {
                        line: 20,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 33
                    },
                    end: {
                        line: 31,
                        column: 2
                    }
                },
                line: 20
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 34,
                        column: 1
                    },
                    end: {
                        line: 34,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 53
                    },
                    end: {
                        line: 38,
                        column: 2
                    }
                },
                line: 34
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 40,
                        column: 1
                    },
                    end: {
                        line: 40,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 30
                    },
                    end: {
                        line: 44,
                        column: 2
                    }
                },
                line: 40
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 46,
                        column: 19
                    },
                    end: {
                        line: 46,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 46,
                        column: 31
                    },
                    end: {
                        line: 54,
                        column: 2
                    }
                },
                line: 46
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 56,
                        column: 1
                    },
                    end: {
                        line: 56,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 41
                    },
                    end: {
                        line: 113,
                        column: 2
                    }
                },
                line: 56
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 69,
                        column: 30
                    },
                    end: {
                        line: 69,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 36
                    },
                    end: {
                        line: 73,
                        column: 5
                    }
                },
                line: 69
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 23,
                        column: 24
                    },
                    end: {
                        line: 25,
                        column: 8
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 24,
                            column: 5
                        },
                        end: {
                            line: 24,
                            column: 35
                        }
                    }, {
                        start: {
                            line: 25,
                            column: 5
                        },
                        end: {
                            line: 25,
                            column: 8
                        }
                    }],
                line: 23
            },
            "1": {
                loc: {
                    start: {
                        line: 41,
                        column: 2
                    },
                    end: {
                        line: 43,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 41,
                            column: 2
                        },
                        end: {
                            line: 43,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 41
            },
            "2": {
                loc: {
                    start: {
                        line: 47,
                        column: 2
                    },
                    end: {
                        line: 49,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 47,
                            column: 2
                        },
                        end: {
                            line: 49,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 47
            },
            "3": {
                loc: {
                    start: {
                        line: 51,
                        column: 2
                    },
                    end: {
                        line: 53,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 51,
                            column: 2
                        },
                        end: {
                            line: 53,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 51
            },
            "4": {
                loc: {
                    start: {
                        line: 62,
                        column: 2
                    },
                    end: {
                        line: 110,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 62,
                            column: 2
                        },
                        end: {
                            line: 110,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 62
            },
            "5": {
                loc: {
                    start: {
                        line: 63,
                        column: 3
                    },
                    end: {
                        line: 74,
                        column: 4
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 63,
                            column: 3
                        },
                        end: {
                            line: 74,
                            column: 4
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 63
            },
            "6": {
                loc: {
                    start: {
                        line: 64,
                        column: 4
                    },
                    end: {
                        line: 66,
                        column: 21
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 64,
                            column: 4
                        },
                        end: {
                            line: 64,
                            column: 18
                        }
                    }, {
                        start: {
                            line: 65,
                            column: 4
                        },
                        end: {
                            line: 65,
                            column: 39
                        }
                    }, {
                        start: {
                            line: 66,
                            column: 4
                        },
                        end: {
                            line: 66,
                            column: 21
                        }
                    }],
                line: 64
            },
            "7": {
                loc: {
                    start: {
                        line: 84,
                        column: 7
                    },
                    end: {
                        line: 95,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 84,
                            column: 7
                        },
                        end: {
                            line: 84,
                            column: 22
                        }
                    }, {
                        start: {
                            line: 84,
                            column: 26
                        },
                        end: {
                            line: 84,
                            column: 43
                        }
                    }, {
                        start: {
                            line: 85,
                            column: 7
                        },
                        end: {
                            line: 94,
                            column: 24
                        }
                    }],
                line: 84
            },
            "8": {
                loc: {
                    start: {
                        line: 96,
                        column: 7
                    },
                    end: {
                        line: 106,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 96,
                            column: 8
                        },
                        end: {
                            line: 96,
                            column: 24
                        }
                    }, {
                        start: {
                            line: 97,
                            column: 8
                        },
                        end: {
                            line: 97,
                            column: 23
                        }
                    }, {
                        start: {
                            line: 97,
                            column: 27
                        },
                        end: {
                            line: 97,
                            column: 44
                        }
                    }, {
                        start: {
                            line: 98,
                            column: 7
                        },
                        end: {
                            line: 105,
                            column: 24
                        }
                    }],
                line: 96
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0],
            "5": [0, 0],
            "6": [0, 0, 0],
            "7": [0, 0, 0],
            "8": [0, 0, 0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "ebfe623b4889890c2935b222f6ab64942de79795"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_eb2cf78kx = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_eb2cf78kx();
import * as Sentry from '@sentry/react';
import * as React from 'react';
const wss = (cov_eb2cf78kx().s[0]++, window.sessionStorage);
const LOCAL_STORAGE_KEY = (cov_eb2cf78kx().s[1]++, 'chunkReloadRetry');
const RELOAD_TIMEOUT = (cov_eb2cf78kx().s[2]++, 20);
class SentryComponent extends (React.PureComponent) {
    constructor(props) {
        cov_eb2cf78kx().f[0]++;
        cov_eb2cf78kx().s[4]++;
        super(props);
        this.timeout = (cov_eb2cf78kx().s[3]++, null);
        this.showErrorDialog = (cov_eb2cf78kx().s[11]++, () => {
            cov_eb2cf78kx().f[3]++;
            cov_eb2cf78kx().s[12]++;
            if (this.timeout) {
                cov_eb2cf78kx().b[2][0]++;
                cov_eb2cf78kx().s[13]++;
                clearTimeout(this.timeout);
            }
            else {
                cov_eb2cf78kx().b[2][1]++;
            }
            cov_eb2cf78kx().s[14]++;
            if (Sentry.lastEventId()) {
                cov_eb2cf78kx().b[3][0]++;
                cov_eb2cf78kx().s[15]++;
                Sentry.showReportDialog();
            }
            else {
                cov_eb2cf78kx().b[3][1]++;
            }
        });
        const reloadAttempt = (cov_eb2cf78kx().s[5]++, (wss === null || wss === void 0 ? void 0 : wss.getItem(LOCAL_STORAGE_KEY)) ? (cov_eb2cf78kx().b[0][0]++, wss.getItem(LOCAL_STORAGE_KEY)) : (cov_eb2cf78kx().b[0][1]++, '0'));
        cov_eb2cf78kx().s[6]++;
        this.state = {
            error: null,
            reloadAttempt: parseInt(reloadAttempt)
        };
    }
    componentDidCatch(error, errorInfo) {
        cov_eb2cf78kx().f[1]++;
        cov_eb2cf78kx().s[7]++;
        this.setState({
            error
        });
        cov_eb2cf78kx().s[8]++;
        Sentry.captureException(error, {
            extra: errorInfo
        });
    }
    componentWillUnmount() {
        cov_eb2cf78kx().f[2]++;
        cov_eb2cf78kx().s[9]++;
        if (this.timeout) {
            cov_eb2cf78kx().b[1][0]++;
            cov_eb2cf78kx().s[10]++;
            clearTimeout(this.timeout);
        }
        else {
            cov_eb2cf78kx().b[1][1]++;
        }
    }
    render() {
        cov_eb2cf78kx().f[4]++;
        const { error, reloadAttempt } = (cov_eb2cf78kx().s[16]++, this.state);
        const { style } = (cov_eb2cf78kx().s[17]++, this.props);
        const chunkFailedMessage = (cov_eb2cf78kx().s[18]++, /ChunkLoadError/);
        let chunkLoadFailed = (cov_eb2cf78kx().s[19]++, false);
        cov_eb2cf78kx().s[20]++;
        if (error) {
            cov_eb2cf78kx().b[4][0]++;
            cov_eb2cf78kx().s[21]++;
            if ((cov_eb2cf78kx().b[6][0]++, error === null || error === void 0 ? void 0 : error.message) && (cov_eb2cf78kx().b[6][1]++, chunkFailedMessage.test(error.name)) && (cov_eb2cf78kx().b[6][2]++, reloadAttempt < 1)) {
                cov_eb2cf78kx().b[5][0]++;
                cov_eb2cf78kx().s[22]++;
                chunkLoadFailed = true;
                cov_eb2cf78kx().s[23]++;
                this.timeout = setTimeout(() => {
                    cov_eb2cf78kx().f[5]++;
                    cov_eb2cf78kx().s[24]++;
                    wss.setItem(LOCAL_STORAGE_KEY, `${reloadAttempt + 1}`);
                    cov_eb2cf78kx().s[25]++;
                    return location.reload();
                }, RELOAD_TIMEOUT * 1000);
            }
            else {
                cov_eb2cf78kx().b[5][1]++;
            }
            cov_eb2cf78kx().s[26]++;
            return React.createElement("div", {
                className: "sentry-error",
                style: style
            }, React.createElement("div", {
                className: "message"
            }, "We're sorry \u2014 something's gone wrong.", React.createElement("br", null), (cov_eb2cf78kx().b[7][0]++, chunkLoadFailed) && (cov_eb2cf78kx().b[7][1]++, reloadAttempt < 1) && (cov_eb2cf78kx().b[7][2]++, React.createElement(React.Fragment, null, "This page will reload in ", RELOAD_TIMEOUT, ' ', "seconds in an attempt to recover. To stop the reload and fill out a report", React.createElement("a", {
                onClick: this.showErrorDialog
            }, ' ', "click here", ' '), ".")), ((cov_eb2cf78kx().b[8][0]++, !chunkLoadFailed) || (cov_eb2cf78kx().b[8][1]++, chunkLoadFailed) && (cov_eb2cf78kx().b[8][2]++, reloadAttempt > 0)) && (cov_eb2cf78kx().b[8][3]++, React.createElement(React.Fragment, null, "Our team has been notified, but", React.createElement("a", {
                onClick: this.showErrorDialog
            }, ' ', "click here", ' '), ' ', "to fill out a report."))));
        }
        else {
            cov_eb2cf78kx().b[4][1]++;
        }
        cov_eb2cf78kx().s[27]++;
        return this.props.children;
    }
}
export default SentryComponent;
